var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBoat = function SvgIconBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 2.25a1 1 0 1 0-2 0V3.5H6a1.75 1.75 0 0 0-1.75 1.75v4.532l-1.047.35h-.002A1.75 1.75 0 0 0 2 11.794V15a1 1 0 0 0 .039.275c.79 2.763 2.99 4.55 4.984 5.651a18.8 18.8 0 0 0 4.573 1.759c.265.065.543.065.808 0 .611-.144 2.57-.652 4.573-1.759 1.994-1.102 4.193-2.887 4.984-5.65Q22 15.14 22 15v-3.206a1.75 1.75 0 0 0-1.2-1.662h-.003l-1.047-.35V5.25A1.75 1.75 0 0 0 18 3.5h-5zm4.75 6.863V5.5H6.25v3.613l5.199-1.736.023-.008a1.8 1.8 0 0 1 1.056 0l.023.008zM4 11.973l7-2.338v6.115a1 1 0 1 0 2 0V9.635l7 2.339v2.88c-.61 1.95-2.232 3.35-3.99 4.322-1.72.95-3.425 1.409-4.01 1.549-.585-.14-2.29-.6-4.01-1.55-1.759-.972-3.38-2.37-3.99-4.321z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBoat;